import LabServiceModel from "@/models/LabServiceModel";
import SampleModel from "./SampleModel";
import TestPackageSampleModel from "./TestPackageSampleModel";

export default class SampleTestPackageModel extends LabServiceModel {
  modelName() {
    return 'sample-test-package';
  }
  defaults() {
    return {
      id: null,
      sample_id: null,
      sample: null,
      test_package_sample_id: null,
      test_package_sample: null,
      add_on: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_id: (val) => (this.nullStringMutator(val)),
      test_package_sample_id: (val) => (this.nullStringMutator(val)),
      add_on: (val) => (this.nullBoolMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getSample() {
    return this.getRelatedModel(SampleModel, 'sample');
  }
  getTestPackageSample() {
    return this.getRelatedModel(TestPackageSampleModel, 'test_package_sample');
  }
}
